import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

export default function ThreeDotsLoader() {
    return <ThreeDots wrapperStyle={{ display: '' }} color="#fff" height={16} width={40} />;
}
